<template>
  <div class="w-box">
    <div class="w-top">
      <van-field is-link label="提现至：" @click="onClick">
        <template #input>
          <div class="w-img">
            <span>{{checkBankName}}  ({{checkBankNum}})</span>
          </div>
        </template>
      </van-field>
    </div>
    <div class="w-num">
      <div class="num-title">
        <div class="t-left">提现金额</div>
        <div class="t-right" @click="clickBalance()">全部提现</div>
      </div>
      <van-field v-model="value1" placeholder="请输入提现金额">
        <template #left-icon>
          <img class="left-icon" src="./img/icon0.png" alt />
        </template>
      </van-field>
    </div>
    <div class="w-hint">
      当前积分
      <span>{{balance || 0}}</span>，可提现总金额
      <span>{{balance || 0}}</span>
    </div>
    <div class="w-but" @click="onWithdraw"></div>
    <van-popup closeable close-icon-position="top-left" v-model="show" position="bottom">
      <div class="pop-title">选择提现银行卡</div>
      <div class="pop-box" v-for="(item,index) in bankList" :key="index" @click="onCheckPop(item,index)">
        <div class="w-img">
          <!-- <img :src="item.img" alt /> -->
          <span>{{item.bankName}}</span>
          <span>({{item.bankAccount}})</span>
          <van-icon v-if="item.defaultCard=='1'" name="success" />
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import URLTB from "@/api/apiTB";
import { Toast } from 'vant';
export default {
  data() {
    return {
      show: false,
      value1: '',
      bankList:[
        {img:require('./img/icon.png'),number:'1555'},
        {img:require('./img/icon.png'),number:'1556'},
        {img:require('./img/icon.png'),number:'1557'},
        {img:require('./img/icon.png'),number:'1558'},
      ],
      checkBankName:'',
      checkBankNum:'',
      balance:''//当前可提现积分
    }
  },
  mounted(){
    this.getCards()
    this.balance=this.$route.query.balance
  },
  methods: {
    getCards(){
      let data={
        userId:localStorage.getItem('userid')
      }
      this.$fetchGet(URLTB.getCards.url,data).then(res=>{
        this.bankList=res.data.data
        this.bankList.map(x=>{
          if(x.defaultCard=='1'){
            this.checkBankName=x.bankName 
            this.checkBankNum= x.bankAccount 
          }
        })
      })
    },
    clickBalance(){//全部提现
      if(this.balance>0){
        this.value1=this.balance
      }else{
        Toast('暂无可提现积分')
      }
    },
    onWithdraw(){//确认提现
    if(this.balance<=0){
      Toast('暂无可提现积分')
      return
    }
    let data={
      userId:localStorage.getItem('userid'),
      agentMobile:localStorage.getItem('phone'), // 代理人手机号
      cashAmount:this.value1 // 提现金额
    }
    this.$fetchPost(URLTB.agentCash.url,this.$toFormData(data)).then(res=>{
      if(res.data.code==20000){
        Toast(res.data.msg)
        this.$router.go(-1)
      }
    })
    },
    onClick() {
        this.show=true
    },
    onCheckPop(item,index){
        let data={
          userId:localStorage.getItem('userid'),
          id:item.id
        }
        this.$fetchPost(URLTB.editCards.url,this.$toFormData(data)).then(res=>{
          if(res.data.code==20000){
            this.getCards()
          }
        })
        this.show=false
    }
  }
}
</script>

<style lang="less" scoped>
.w-box {
  font-family: Source Han Sans CN;
  font-weight: 500;
  .w-img {
    display: flex;
    align-items: center;
    span {
      font-weight: 400;
      font-size: 13px;
      color: #333333;
      &:last-child{
        padding-left: 10px;
      }
    }
  }
  .w-top {
    .van-cell {
      height: 60px;
      align-items: center;
      padding: 0 10px;
    }
  }
  .w-num {
    width: 375px;
    height: 101px;
    margin-top: 10px;
    background: url("./img/bg4.png") no-repeat 100%;
    background-size: 100% 100%;
    .num-title {
      padding: 18px 10px 25px 10px;
      display: flex;
      justify-content: space-between;
      font-size: 13px;
      font-weight: 500;
    }
    .t-right {
      font-weight: 400;
      color: #fc6e09;
    }
    .van-cell {
      padding: 0 10px;
      line-height: 21px;
      font-size: 18px;
      .left-icon {
        width: 16px;
        height: 21px;
        margin-right: 10px;
      }
    }
  }
  .w-hint {
    margin: 15px 0 0 10px;
    font-size: 13px;
    color: #666666;
    span {
      color: #fc6e09;
    }
  }
  .w-but {
    width: 355px;
    height: 53px;
    margin: 74px auto auto;
    background: url("./img/but1.png") no-repeat 100%;
    background-size: 100% 100%;
  }
  .pop-title {
    text-align: center;
    padding: 15px 0;
    font-size: 13px;
    color: #333333;
  }
  .pop-box{
    width: 322px;
    margin: auto;
    height: 53px;
    line-height: 53px;
    border-bottom: 1px solid #EDEDED;
    .van-icon{
        margin-left: 50px;
        color: #FC6E09;
    }
  }
}
</style>